import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Component, OnInit, Inject } from '@angular/core';


@Component({
  selector: 'app-usersSiteDeleteModal',
  templateUrl: '../templates/deleteUserModal.component.html'
})
export class DeleteUserModalComponent implements OnInit {
  errorMessage: string;

  constructor(private dialogRef: MatDialogRef<DeleteUserModalComponent>, @Inject(MAT_DIALOG_DATA)
  private data: { CancelResult: boolean }) {
  }

  ngOnInit() {
    
  }

  deleteUser() {
    this.dialogRef.close(true);
  }

  close() {
    this.dialogRef.close(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/users/components/scripts/deleteUserModal.component.ts